import {
  APP_IDS,
  TIMELY_HOSTS,
  getRuntimeAppProfile,
} from "../runtime/appProfile";

const BOOKING_HOSTS = TIMELY_HOSTS;

const CARE_HOSTS = new Set(["care.plany365.com"]);

const LOCAL_HOSTS = new Set(["localhost", "127.0.0.1"]);

const PUBLIC_HOST_BY_VERTICAL = {
  booking: "timely365.com",
  care: "care.plany365.com",
};

export const PROVIDER_PORTAL_HOST = "providers.plany365.com";

export function getNormalizedHostname() {
  if (typeof window === "undefined") return "";
  return String(window.location.hostname || "").trim().toLowerCase();
}

export function isLocalHostname(hostname = getNormalizedHostname()) {
  return LOCAL_HOSTS.has(hostname);
}

export function isBookingBrandHost(hostname = getNormalizedHostname()) {
  return BOOKING_HOSTS.has(hostname);
}

export function isCareBrandHost(hostname = getNormalizedHostname()) {
  return CARE_HOSTS.has(hostname);
}

export function getBrandVertical(hostname = getNormalizedHostname()) {
  if (getRuntimeAppProfile(hostname).id === APP_IDS.TIMELY) return "booking";
  if (isCareBrandHost(hostname)) return "care";
  return "";
}

export function getPublicHostForVertical(verticalId) {
  return PUBLIC_HOST_BY_VERTICAL[String(verticalId || "").trim().toLowerCase()] || null;
}

export function shouldCrossDomainNavigate(targetHost) {
  if (!targetHost) return false;
  const currentHost = getNormalizedHostname();
  if (!currentHost || isLocalHostname(currentHost)) return false;

  const normalizedTarget = String(targetHost || "").trim().toLowerCase();
  if (!normalizedTarget) return false;

  return currentHost !== normalizedTarget;
}

export function buildHttpsUrl(targetHost, path = "/") {
  const normalizedPath = String(path || "/").startsWith("/") ? String(path || "/") : `/${path}`;
  return `https://${String(targetHost || "").trim().toLowerCase()}${normalizedPath}`;
}

export function applyHostBranding(text) {
  const raw = String(text || "");
  if (!raw) return raw;
  if (!isBookingBrandHost()) return raw;
  return raw.replace(/Plany365/g, "Timely365");
}
